import { render, staticRenderFns } from "./brace-copy.vue?vue&type=template&id=5bfe3ca8"
import script from "./brace-copy.vue?vue&type=script&lang=js"
export * from "./brace-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports